<template>
    <header
        :style="`padding-right: ${headerPadding}`"
        :class="isSticky ? 'top-3 md:top-0' : 'top-3 md:top-10'"
        class="fixed left-0 right-0 z-50 transition-[top]">
        <div class="container relative">
            <div
                class="relative flex items-center rounded-20 bg-[#35077099] py-2 text-white backdrop-blur-md transition-all duration-500 max-md:container max-lg:justify-between md:p-5 xl:text-16/120">
                <button
                    aria-label="меню контактов"
                    class="ml-1 lg:hidden"
                    @click="openModal('contactMenu')">
                    <AtomIcon
                        name="phone"
                        class="size-8" />
                </button>
                <NuxtLink
                    to="/"
                    aria-label="На главную страницу, логотип компании 'Кроми'"
                    class="inline-flex items-center">
                    <TheLogotype
                        class="h-auto w-[3.875rem] shrink-0 md:w-[4rem]" />

                    <p
                        v-if="isRent()"
                        class="ml-3 text-12/116 font-semibold leading-[124%] text-ash-200">
                        Аренда<br />
                        оборудования<br />
                        для мероприятий
                    </p>
                    <p
                        v-if="isRadioguide()"
                        class="ml-3 text-16/120 font-semibold text-ash-200">
                        Аренда <br />
                        радиогидов
                    </p>
                </NuxtLink>

                <HeaderNav />

                <div
                    :class="isCromi() ? 'lg:space-x-5' : 'lg:space-x-10'"
                    class="flex items-center lg:ml-auto">
                    <div class="hidden flex-col space-y-1 xl:flex">
                        <span class="text-12/116 font-medium"> Москва </span>
                        <a
                            href="tel:+74994996030"
                            class="text-16/120 font-medium transition-colors duration-150 hover:text-accent-400 active:text-accent">
                            +7&nbsp;499&nbsp;499-60-30
                        </a>
                    </div>
                    <div class="hidden flex-col space-y-1 xl:flex">
                        <span class="text-12/116 font-medium">
                            Санкт-Петербург
                        </span>
                        <a
                            href="tel:+78124906030"
                            class="text-16/120 font-medium transition-colors duration-150 hover:text-accent-400 active:text-accent">
                            +7&nbsp;812&nbsp;490-60-30
                        </a>
                    </div>
                    <div
                        :class="isCromi() ? 'lg:space-x-3' : 'lg:space-x-5'"
                        class="flex items-center">
                        <AtomButton
                            class="max-lg:hidden"
                            @click="openFeedback">
                            Связаться
                        </AtomButton>
                        <button
                            v-if="config.public.website !== 'radioguide.rent'"
                            type="button"
                            aria-label="поиск"
                            class="max-lg:hidden"
                            @click="openSearchModal">
                            <AtomIcon
                                name="search"
                                class="size-10" />
                        </button>
                        <button
                            type="button"
                            aria-label="меню"
                            class="max-lg:hidden"
                            @click="openModal()">
                            <AtomIcon
                                name="burger"
                                class="size-10" />
                        </button>
                        <button
                            type="button"
                            aria-label="меню"
                            class="lg:hidden"
                            @click="openModal('mobileMenu')">
                            <AtomIcon
                                name="burger"
                                class="size-10" />
                        </button>
                    </div>
                </div>
            </div>
            <!--          todo: Объедените BurgerMenuModal и MobileBurgerMenu  в один компонент -->
            <BurgerMenuModal
                :is-open="isBurgerMenuOpen"
                @open-search-modal="openSearchModal"
                @close="closeModal" />
            <MobileBurgerMenuModal
                :is-open="modalStore.modals.mobileMenu"
                @open-search-modal="openSearchModal"
                @close="closeModal" />
            <ContactMenuModal
                :is-open="modalStore.modals.contactMenu"
                @close="closeModal" />
        </div>
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            class="absolute left-0 top-0 opacity-0">
            <mask
                id="path-1-outside-1_3001_798"
                maskUnits="userSpaceOnUse"
                x="2"
                y="5"
                fill="black"
                width="20"
                height="14">
                <rect
                    fill="white"
                    x="2"
                    y="5"
                    width="20"
                    height="14" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 8C10 6.89543 10.8954 6 12 6H19C20.1046 6 21 6.89543 21 8V14C21 15.1046 20.1046 16 19 16H17.9146C17.9699 16.1564 18 16.3247 18 16.5C18 17.3284 17.3284 18 16.5 18C15.6716 18 15 17.3284 15 16.5C15 16.3247 15.0301 16.1564 15.0854 16H13H10H8.91465C8.96992 16.1564 9 16.3247 9 16.5C9 17.3284 8.32843 18 7.5 18C6.67157 18 6 17.3284 6 16.5C6 16.3247 6.03008 16.1564 6.08535 16H5C3.89543 16 3 15.1046 3 14C3 12.8954 3.89543 12 5 12H10V8ZM7 8C5.89543 8 5 8.89543 5 10V11H9V8H7Z" />
            </mask>
            <path
                d="M17.9146 16V15H16.5006L16.9718 16.3332L17.9146 16ZM15.0854 16L16.0282 16.3332L16.4994 15H15.0854V16ZM8.91465 16V15H7.50057L7.97181 16.3332L8.91465 16ZM6.08535 16L7.02819 16.3332L7.49943 15H6.08535V16ZM10 12V13H11V12H10ZM5 11H4V12H5V11ZM9 11V12H10V11H9ZM9 8H10V7H9V8ZM12 5C10.3431 5 9 6.34315 9 8H11C11 7.44772 11.4477 7 12 7V5ZM19 5H12V7H19V5ZM22 8C22 6.34315 20.6569 5 19 5V7C19.5523 7 20 7.44772 20 8H22ZM22 14V8H20V14H22ZM19 17C20.6569 17 22 15.6569 22 14H20C20 14.5523 19.5523 15 19 15V17ZM17.9146 17H19V15H17.9146V17ZM16.9718 16.3332C16.9898 16.3841 17 16.4398 17 16.5H19C19 16.2096 18.9501 15.9287 18.8575 15.6668L16.9718 16.3332ZM17 16.5C17 16.7761 16.7761 17 16.5 17V19C17.8807 19 19 17.8807 19 16.5H17ZM16.5 17C16.2239 17 16 16.7761 16 16.5H14C14 17.8807 15.1193 19 16.5 19V17ZM16 16.5C16 16.4398 16.0102 16.3841 16.0282 16.3332L14.1425 15.6668C14.0499 15.9287 14 16.2096 14 16.5H16ZM13 17H15.0854V15H13V17ZM10 17H13V15H10V17ZM8.91465 17H10V15H8.91465V17ZM10 16.5C10 16.2096 9.95007 15.9287 9.85749 15.6668L7.97181 16.3332C7.98978 16.3841 8 16.4398 8 16.5H10ZM7.5 19C8.88071 19 10 17.8807 10 16.5H8C8 16.7761 7.77614 17 7.5 17V19ZM5 16.5C5 17.8807 6.11929 19 7.5 19V17C7.22386 17 7 16.7761 7 16.5H5ZM5.14251 15.6668C5.04993 15.9287 5 16.2096 5 16.5H7C7 16.4398 7.01022 16.3841 7.02819 16.3332L5.14251 15.6668ZM5 17H6.08535V15H5V17ZM2 14C2 15.6569 3.34315 17 5 17V15C4.44772 15 4 14.5523 4 14H2ZM5 11C3.34315 11 2 12.3431 2 14H4C4 13.4477 4.44772 13 5 13V11ZM10 11H5V13H10V11ZM9 8V12H11V8H9ZM6 10C6 9.44772 6.44772 9 7 9V7C5.34315 7 4 8.34315 4 10H6ZM6 11V10H4V11H6ZM9 10H5V12H9V10ZM8 8V11H10V8H8ZM7 9H9V7H7V9Z"
                fill="#5A5A5A"
                mask="url(#path-1-outside-1_3001_798)" />
            <circle
                cx="16.5"
                cy="16.5"
                r="2"
                stroke="#5A5A5A" />
            <circle
                cx="7.5"
                cy="16.5"
                r="2"
                stroke="#5A5A5A" />
        </svg>
    </header>
    <Teleport to="#teleports">
        <SearchModal
            :is-open="isSearchModalOpen"
            @close="closeSearchModal" />
    </Teleport>
</template>

<script setup lang="ts">
import TheLogotype from '~/components/TheLogotype.vue'
import AtomButton from '~/components/atom/atom-button/AtomButton.vue'
import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'
import HeaderNav from '~/components/layouts/header/HeaderNav.vue'
import BurgerMenuModal from '~/components/modals/burger-menu/BurgerMenuModal.vue'
import MobileBurgerMenuModal from '~/components/modals/burger-menu/MobileBurgerMenuModal.vue'
import ContactMenuModal from '~/components/modals/contact-menu/ContactMenuModal.vue'
import SearchModal from '~/components/modals/search-modal/SearchModal.vue'

const isSticky = ref(false)
const headerPadding = ref('0px')
const isBurgerMenuOpen = ref(false)
const isSearchModalOpen = ref(false)
const modalStore = useModalStore()
const config = useRuntimeConfig()
const route = useRoute()

const { hasOpenModal } = storeToRefs(modalStore)

function openSearchModal() {
    isSearchModalOpen.value = true
}
function closeSearchModal() {
    isSearchModalOpen.value = false
}

function handleScroll() {
    isSticky.value = window.scrollY > 0
}

function openModal(name?: 'contactMenu' | 'mobileMenu') {
    switch (name) {
        case 'contactMenu':
            isBurgerMenuOpen.value = false
            modalStore.setFormName('Контактное меню, кнопка "Отправить заявку"')
            modalStore.open('contactMenu')
            break
        case 'mobileMenu':
            isBurgerMenuOpen.value = false
            modalStore.open('mobileMenu')
            break
        default:
            isBurgerMenuOpen.value = true
            queueMicrotask(() => {
                const calltouchWindow = window as Window & {
                    ct_replace_dynamic_mail?: () => void
                }

                calltouchWindow.ct_replace_dynamic_mail?.()
            })
    }
}

watch(hasOpenModal, async () => {
    queueMicrotask(() => {
        headerPadding.value = window.document.documentElement.style.paddingRight
    })
})

watch(isBurgerMenuOpen, async () => {
    queueMicrotask(() => {
        headerPadding.value = window.document.documentElement.style.paddingRight
    })
})

function closeModal() {
    isBurgerMenuOpen.value = false
}

function openFeedback() {
    modalStore.setFeedbackLabel(modalStore.headerFeedbackLabel)
    modalStore.setFormName('Шапка сайта, кнопка "Связаться"')

    if (isCromi() && route.name === 'direction-subcategory') {
        modalStore.setFormID(5)
    }

    modalStore.open('feedbackModal')
}

onMounted(() => {
    window.addEventListener('scroll', handleScroll)
    handleScroll()
})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
})
</script>
